import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import cs from './cs.json';
import sk from './sk.json';

i18n.use(initReactI18next).init({
  resources: { cs, sk },
  lng: 'sk',
  debug: false,
  whitelist: ['cs', 'sk'],
  fallbackLng: ['cs', 'sk'],
  // keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
